import { Paper, Stack, Typography } from '@mui/material';
import type { SalesReportResponse } from '../../api/types/salesReports';

/** Backend'in döndürdüğü rapor toplamları (`Report/TicketJson` / `PersonelTicketSalesReport`).
 *  `sumSalesAmount`/`sumProfitAmount` önceden biçimlenmiş para string'leri ("₺33.069,80"),
 *  `sumTicket` bir sayı — hepsi verildiği gibi gösterilir. En az biri doluysa render eder. */
export function SalesReportTotals({ data }: { data: SalesReportResponse | undefined }) {
  if (!data) return null;
  const { sumTicket, sumSalesAmount, sumProfitAmount } = data;
  if (sumTicket == null && !sumSalesAmount && !sumProfitAmount) return null;

  const items: { label: string; value: string }[] = [];
  if (sumTicket != null) items.push({ label: 'Toplam Bilet', value: sumTicket.toLocaleString('tr-TR') });
  if (sumSalesAmount) items.push({ label: 'Toplam Satış', value: sumSalesAmount });
  if (sumProfitAmount) items.push({ label: 'Toplam Kâr', value: sumProfitAmount });

  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mb: 2 }}>
      {items.map((item) => (
        <Paper key={item.label} variant="outlined" sx={{ px: 2, py: 1.5, flex: 1, minWidth: 140 }}>
          <Typography variant="caption" color="text.secondary" component="div">
            {item.label}
          </Typography>
          <Typography variant="h6">{item.value}</Typography>
        </Paper>
      ))}
    </Stack>
  );
}
